import LineupSettings from "./LineupSettings";
export default LineupSettings;
